import { ReactElement } from 'react';
import { Controller, Control, FieldErrors, FieldValues, Path } from 'react-hook-form';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, TimePicker as MUITimePicker } from '@material-ui/pickers';
import get from 'lodash/get';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

import { ReactComponent as ClockIcon } from '~/ui/assets/images/clockIcon.svg';
import styles from './TimePicker.module.scss';

interface IProps<TFieldValues extends FieldValues = FieldValues> {
  control: Control<TFieldValues>;
  errors: FieldErrors;
  name: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: 'small' | 'medium';
}

const TimePicker = <TFieldValues extends FieldValues = FieldValues>({
  control,
  name,
  label,
  errors,
  placeholder,
  disabled,
  size = 'small',
}: IProps<TFieldValues>): ReactElement => {
  const error = get(errors, `${name}.message`, '');

  return (
    <Controller
      control={control}
      name={name as Path<TFieldValues>}
      render={({ field: { value, onChange } }) => (
        <>
          <FormControl variant="outlined" size={size} fullWidth>
            {label && <InputLabel shrink>{label}</InputLabel>}
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <MUITimePicker
                error={!!error}
                fullWidth
                inputVariant="outlined"
                size={size}
                value={(value as Date | string | number) || null}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                InputProps={{
                  endAdornment: <ClockIcon />,
                }}
              />
            </MuiPickersUtilsProvider>
            {error && (
              <FormHelperText error className={styles.errorText}>
                {error.toString()}
              </FormHelperText>
            )}
          </FormControl>
        </>
      )}
    />
  );
};

export default TimePicker;
